import { Pressable, StyleSheet, View, Text } from "react-native";
import React from "react";
import SalesSVG from "@assets/svg/Sales";
import SalesSelectedSVG from "@assets/svg/SalesSelected";
import { scale } from "@utils/scale";
import testIds from "@constants/testIds";

const SalesRow = ({ selectedSale, item, onPress = () => {} }) => {
  const { month, year, sales } = item;
  const mo = item.month.substring(5, 7);
  const y = item.month.substring(0, 4);
  const months = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  function formatAmount(num) {
    return (num + "").replace(/\B(?=(?:\d{3})+\b)/g, ",");
  }
  return (
    <Pressable
      style={styles.container}
      onPress={onPress}
      testID={`${month}-${testIds.tab}`}
    >
      <View style={styles.leftPartition}>
        <Text style={selectedSale ? styles.monthSelected : styles.monthtext}>
          {months[parseInt(mo)].substring(0, 3)}, {y}
        </Text>
      </View>
      <View style={styles.rightPartition}>
        {selectedSale ? (
          <View style={[styles.sales, { marginTop: scale(-6) }]}>
            <SalesSelectedSVG heigh={16} width={16} />
          </View>
        ) : (
          <View style={styles.sales}>
            <SalesSVG heigh={15} width={15} />
          </View>
        )}
        <View style={{ flexDirection: "row" }}>
          <Text style={selectedSale ? styles.selectedInr : styles.inr}>₹</Text>

          <Text
            style={
              selectedSale
                ? styles.amountSelected
                : [styles.amounttext, styles.amt]
            }
          >
            {formatAmount(parseInt(item.totalSales))}
          </Text>
        </View>
      </View>
    </Pressable>
  );
};

export default SalesRow;

const styles = StyleSheet.create({
  leftPartition: {
    marginTop: scale(6),
  },
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginLeft: scale(24),
    width: "79%",
    paddingVertical: scale(10),
  },
  monthSelected: {
    fontSize: scale(20),
    lineHeight: scale(24),
    color: "#FF7A00",
    fontFamily: "NotoSansDevanagari-Bold",
  },
  amountSelected: {
    fontSize: scale(24),
    lineHeight: scale(28),
    color: "#FF7A00",
    fontFamily: "NotoSansDevanagari-ExtraBold",
  },
  selectedInr: {
    fontSize: scale(24),
    lineHeight: scale(28),
    color: "#FF7A00",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  inr: {
    fontSize: scale(18),
    lineHeight: scale(27),
    color: "#0000008f",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  monthtext: {
    fontWeight: "600",
    fontSize: scale(16),
    lineHeight: scale(24),
    color: "#0000008f",
    fontFamily: "NotoSansDevanagari-Medium",
  },
  amounttext: {
    fontWeight: "600",
    fontSize: scale(18),
    lineHeight: scale(27),
    color: "#0000008f",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  amt: {
    fontFamily: "NotoSansDevanagari-Bold",
  },
  rightPartition: {
    flexDirection: "row",
    width: "47%",
    alignItems: "center",
    marginTop: scale(4),
  },

  sales: {
    marginRight: scale(4),
    marginLeft: scale(-2),
    justifyContent: "center",
  },
});
